import { lazy } from 'react'
import { Route, RouteProps, Routes } from 'react-router-dom'
import LoaderPage from 'components/ui/feedback/LoaderPage'

const HomePortalPage = lazy(() => import('pages/home/page'))

const HomeRoutes: React.FunctionComponent<RouteProps> = () => {
  return (
    <Routes>
      <Route path="/" element={<LoaderPage content={<HomePortalPage />} />} />
    </Routes>
  )
}

export default HomeRoutes
